import { render, staticRenderFns } from "./LayTranslate.vue?vue&type=template&id=e3ce9e5e&scoped=true&"
import script from "./LayTranslate.vue?vue&type=script&lang=js&"
export * from "./LayTranslate.vue?vue&type=script&lang=js&"
import style0 from "./LayTranslate.vue?vue&type=style&index=0&id=e3ce9e5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ce9e5e",
  null
  
)

export default component.exports